import { mapValues } from 'lodash';
import { find, findLast } from 'ramda';
import * as yup from 'yup';

import { AddSubcategoriesFormValues } from './types';
import { UNIQUEID_CATEGORY_PREFIX } from '../constants';

const isDuplicateSubcategories = (
  subcategory: { _rowId: string; name: string },
  subcategories: { _rowId: string; name: string }[],
) => {
  const firstCategory = find(v => v.name === subcategory.name, subcategories);
  const lastCategory = findLast(v => v.name === subcategory.name, subcategories);
  const isDuplicate = firstCategory?._rowId !== lastCategory?._rowId;

  if (isDuplicate) {
    const subcategoryRowNumber = Number(subcategory._rowId.replace(UNIQUEID_CATEGORY_PREFIX, ''));
    const subcategoryRowNumbers = subcategories
      .filter(({ name }) => subcategory.name === name)
      .map(({ _rowId }) => Number(_rowId.replace(UNIQUEID_CATEGORY_PREFIX, '')));
    const isFirstAddedSubcategory = Math.min(...subcategoryRowNumbers) === subcategoryRowNumber;

    return !isFirstAddedSubcategory;
  }

  return false;
};

export const childCategoriesValidationSchema = yup.lazy(
  (childCategoryRecord: AddSubcategoriesFormValues['childCategoriesRecord']) =>
    yup.object(
      mapValues(childCategoryRecord, childCategories =>
        yup.array(
          yup
            .object({
              name: yup.string().max(50).optional(),
            })
            .test(
              'noDuplicates',
              { name: { id: 'validation.noDuplicates' } },
              (childCategory: AddSubcategoriesFormValues['childCategoriesRecord'][string][number]) =>
                childCategory.name === '' || !isDuplicateSubcategories(childCategory, childCategories),
            ),
        ),
      ),
    ),
);
